import { Button } from "../../../../components/button/button";
import TextInputField from "../../../../components/form-fields/text-input-field/text-input-field";
import { Typography } from "@mui/material";
import { DollarIcon, PercentageIcon } from "../../../../utils/svg-components";
import { DiscountFiledWithUnitsStyled } from "./discount-filed-with-units.styles";

const DiscountFieldWithUnits = ({
  label,
  value,
  unit,
  handleValueChange,
  onUnitChange,
}) => {
  const isDollar = unit === "value";
  return (
    <DiscountFiledWithUnitsStyled>
      <div className="label">
        <Typography>{label}</Typography>
      </div>
      <div className="internal">
        <div className="left-btn">
          <Button
            variant={isDollar ? "filled" : "outlined"}
            onClick={() => onUnitChange("value")}
          >
            <DollarIcon />
          </Button>
        </div>

        <TextInputField
          value={value}
          inputType="number"
          placeholder="Total"
          onChange={(e) => handleValueChange(parseFloat(e.target.value))}
        />

        <div className="right-btn">
          <Button
            variant={isDollar ? "outlined" : "filled"}
            onClick={() => onUnitChange("percentage")}
          >
            <PercentageIcon />
          </Button>
        </div>
      </div>
    </DiscountFiledWithUnitsStyled>
  );
};

export default DiscountFieldWithUnits;
